<div class="ui-component" [ngClass]="component | componentClasses" [class.custom-card__wrapper]="isParentBrandContainer">
  <div class="ui-component__content">
    <div class="ui-component__content-wrapper" *ngIf="isLinkInitialized">
      <ng-container *ngIf="isParentBrandContainer">
        <ng-container *ngTemplateOutlet="custom; context: {component: component, link: link}"></ng-container>
      </ng-container>
      <ng-container *ngIf="!isParentBrandContainer" [ngSwitch]="component.componentConfig.selector">
        <ng-container *ngSwitchCase="'ui-card--slide'">
          <ng-container *ngTemplateOutlet="slide; context: {component: component, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--highlight'">
          <ng-container *ngTemplateOutlet="highlight; context: {component: component, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--special-offer'">
          <ng-container *ngTemplateOutlet="highlight; context: {component: component, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--news-preview'">
          <ng-container *ngTemplateOutlet="news; context: {component: component, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--banner'">
          <ng-container *ngTemplateOutlet="banner; context: {component: component, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--destination'">
          <ng-container *ngTemplateOutlet="destination; context: {component: component, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--landing'">
          <ng-container *ngTemplateOutlet="landing; context: {component: component, parent: parent, link: link}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'ui-card--static-section'">
          <ng-container *ngTemplateOutlet="static; context: {component: component, parent: parent, link: link}"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="ui-component__children" *ngIf="component.children">
      <ng-container>
        <ng-content></ng-content>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #categoryTemplate let-category="category">
  <span class="category-badge" *ngIf="category">
     <span class="category-badge__value">{{category.description}}</span>
     <i class="category-badge__icon" [ngClass]="{'icon-star' : category.typology == 'STAR'}"></i>
  </span>
</ng-template>

<ng-template #slide let-component="component" let-link="link">
  <a class="c-slide" [attr.href]="link?.length > 0 && !isLanding ? link : null" target="{{component?.content?.ctaType?.id == 3  ? '_blank' : '_self'}}">
    <div class="image slide-image" style="background-image: url({{component.content.image}})">
      <div class="container c-slide__content">
        <div class="c-slide__top-row" [ngClass]="{'u-flex-row' : component?.content?.ctaType?.id != 1}">
          <div class="c-slide__header">
            <picture class="logo" *ngIf="component.content.products[0]?.tourOperator">
              <img loading="lazy" src="{{component.content.products[0]?.tourOperator.baseUrlMini + component.content.products[0]?.tourOperator.image}}" alt="tour operator logo">
            </picture>
            <div class="title">
              <ng-container *ngIf="component.content?.products[0]?.destinationString">
                <h6>
                  <span class="icon-pin-full destination-icon"></span>{{component.content.products[0].destinationString}}
                </h6>
              </ng-container>

              <h2 [innerHTML]="component.content.title | trustHtml"></h2>
              <div class="prepend-category">
                <ng-container *ngTemplateOutlet="categoryTemplate; context: {category: component.content.products[0]?.accommodation?.category}"></ng-container>
                <h6 class="u-ellipsis--lin-3" [innerHTML]="component.content.subTitle | trustHtml"></h6>
              </div>
            </div>
          </div>
          <span class="c-slide__price" *ngIf="component?.content?.price && component?.content?.price?.length > 0"
                [ngClass]="{'is-loading' : isPriceLoading }">

            <ng-container *ngIf="!this.isPriceLoading">
              <span class="price-value">
                <small class="price-prefix" *ngIf="component.content.pricePrefix">{{component.content.pricePrefix}}</small>
                <ng-container *ngIf="component.content.livePrice && this.livePrice">{{this.livePrice}} €</ng-container>
                <ng-container *ngIf="!component.content.livePrice || !this.livePrice">{{component.content.price}}</ng-container>
              </span>
              <span class="price-suffix" *ngIf="component.content.priceSuffix">
                <ng-container *ngIf="component.content.livePrice && this.livePrice">{{component.content.priceSuffix}}</ng-container>
                <ng-container *ngIf="!component.content.livePrice || !this.livePrice">{{component.content.priceSuffix}}</ng-container>
              </span>
            </ng-container>

            <div class="u-price-loader"><div></div><div></div><div></div><div></div></div>

          </span>
          <div class="c-slide__cta right row" *ngIf="component.content.ctaLabel && component?.content?.ctaType?.id != 1">
            <a class="cta btn btn--brand-color-03 btn--xs-large" target="{{component?.content?.ctaType?.id == 3  ? '_blank' : '_self'}}"
              [attr.href]="link?.length > 0 && !isLanding ? link : null">
              {{component.content.ctaLabel}}
            </a>
          </div>
        </div>

      </div>
    </div>
  </a>
</ng-template>

<ng-template #highlight let-component="component" let-link="link">

  <a class="c-card c-card--vertical" target="{{component?.content?.ctaType?.id == 3  ? '_blank' : '_self'}}"
  [attr.href]="link?.length > 0 && !isLanding ? link : null"
  [ngClass]="{'is-disabled' : !link || link.length < 7 }">
    <picture class="c-card__pic">
      <img src="{{component.content.image}}"
        alt=""
        loading="lazy">
      <div class="c-card__pic-info">
        <div class="c-card__pic-top">
          <span class="c-card__favorite" *ngIf="component.content.products[0]">
            <span class="o-icon o-icon--16"
                  [ngClass]="{'icon-palm-tree' : this.component.content.products[0].productType.description == 'Holiday',
                              'icon-tour' : this.component.content.products[0].productType.description == 'Tour',
                              'icon-cruise' : this.component.content.products[0].productType.description == 'Cruise',
                              'icon-excursion': this.component.content.products[0].productType.description == 'Experience'}">
            </span>
          </span>
        </div>
        <div class="c-card__pic-bottom" *ngIf="component.content.badges.length > 0">
          <ul class="list-inline list-unstyled c-chips">
            <li class="list-inline-item">
              <span class="c-chip c-chip--orange" *ngIf="component.content.badges.length > 0"><i class="icon-target"></i> </span>
            </li>
          </ul>
        </div>
      </div>
    </picture>
    <div class="c-card__body">

      <div class="c-card__main-info">
        <div class="c-card__header">
          <div class="c-card__title">
            <h5 class="h5" style="margin-bottom: 0.125rem; line-height: 1.1" [innerHTML]="component.content.title | trustHtml"></h5>
            <div class="prepend-category">
              <ng-container *ngTemplateOutlet="categoryTemplate; context: {category: component.content.products[0]?.accommodation?.category}">
              </ng-container>
              <span class="c-card__date"></span>
              <span class="c-card__type u-ellipsis--lin-2" [innerHTML]="component.content.subTitle | trustHtml"></span>
            </div>
          </div>
          <!-- Inserisce il logo del tour operator se questo non è GEO -->
          <picture class="c-card__top-logo" *ngIf="component.content.products[0]?.tourOperator?.id != 1016058">
            <img src="{{component.content.products[0]?.tourOperator.baseUrlMini + component.content.products[0]?.tourOperator.image}}" alt="" loading="lazy" />
          </picture>
        </div>

        <div class="d-flex justify-content-between">
          <ul class="list-unstyled custom-list">
            <ng-container *ngIf="component.content.products[0]?.productType?.description == 'Cruise'">
              <li *ngIf="component.content?.products[0]?.destinationString">
                <i class="icon-pin-full"></i>
                <span class="u-text--bold">{{component.content.products[0].destinationString}}</span>
              </li>
              <li *ngIf="component.content?.products[0]?.departureDateFrom">
                <i class="icon-calendar"></i>
                <span class="u-text--medium">{{component.content.products[0].departureDateFrom | date: "dd/MM/yyyy"}}</span>
              </li>
              <li *ngIf="component.content.products[0]?.departurePlace?.name">
                <i class="icon-cruise"></i>
                <span class="u-text--medium" [innerHTML]="component.content.products[0].departurePlace.name | trustHtml"></span>
              </li>
            </ng-container>

            <ng-container *ngIf="component.content.products[0]?.productType?.description != 'Cruise'">
              <li *ngIf="component.content?.products[0]?.destinationString">
                <i class="icon-pin-full"></i>
                <span class="u-text--bold">{{component.content.products[0].destinationString}}</span>
              </li>
              <!-- <li *ngIf="component.content.products[0]?.destination &&
                        !component.content.products[0]?.destinationString?.includes(component.content?.products[0]?.destination?.name)" class="destination">
                <i class="icon-pin"></i>
                <span class="u-text--bold">{{ component.content.products[0].destination.name }}</span>
              </li> -->
              <li *ngIf="component.content?.products[0]?.departureDateFrom">
                <i class="icon-calendar"></i>
                <span class="u-text--medium">{{component.content.products[0].departureDateFrom | date: "dd/MM/yyyy"}}</span>
              </li>
              <li *ngIf="component.content?.products[0]?.basisName">
                <i class="icon-treatment"></i>
                <span class="u-text--medium" [innerHTML]="component.content?.products[0]?.basisName | trustHtml"></span>
              </li>
            </ng-container>
          </ul>

          <!-- Logo Geo Special -->
          <div class="c-card__logo-custom" *ngIf="component.content?.products[0]?.realTourOperator?.id == 1016058 && brand?.networkId == networks.GEO">
            <img loading="lazy" src="./assets/images/logo_geospecial.png" />
          </div>

          <!-- Logo WTG Special -->
          <div class="c-card__logo-custom" *ngIf="component.content?.products[0]?.realTourOperator?.id == 1016058 && brand?.networkId == networks.WTG">
            <img src="./assets/images/logo_welcome-special.png" />
          </div>
        </div>

      </div>

      <div class="c-card__sub-info" [ngClass]="{'justify-content-center' : component?.content?.ctaLabel && (component.content?.ctaType?.id == 2 || component.content?.ctaType?.id == 9)}">
        <div class="c-card__duration" *ngIf="component.content?.products[0]?.productType?.description != 'Cruise' && component.content?.products[0]?.nights">
          <i class="o-icon o-icon--16 icon-time"></i>
          <span><span [innerHTML]="component.content?.products[0]?.nights | trustHtml"></span> notti</span>
        </div>
        <!-- Durata in giorni della cruise (solo wtg) -->
        <div class="c-card__duration" *ngIf="component.content?.products[0]?.productType?.description == 'Cruise' && brand?.networkId == networks.WTG && ((component.content?.products[0]?.departureDateFrom | dateDifference: component.content?.products[0]?.departureDateTo) + 1)">
          <i class="o-icon o-icon--16 icon-time"></i>
          <span><span [innerHTML]="((component.content?.products[0]?.departureDateFrom | dateDifference: component.content?.products[0]?.departureDateTo) + 1) | trustHtml"></span> giorni</span>
        </div>

        <div class="c-card__prices" [ngClass]="{ 'is-loading': isPriceLoading }">
          <ng-container *ngIf="component?.content?.ctaLabel && (component.content?.ctaType?.id == 2 || component.content?.ctaType?.id == 9)">
            <button type="button" class="cta btn btn--brand-color-03 btn--sm-large">{{component.content.ctaLabel}}</button>
          </ng-container>
          <ng-container *ngIf="!this.isPriceLoading && !(component.content?.ctaType?.id == 2 || component.content?.ctaType?.id == 9)">
            <span class="c-card__value">
              <small class="c-card__pp me-1" *ngIf="component.content.pricePrefix">{{ component.content.pricePrefix }}</small>
              <ng-container *ngIf="component.content.livePrice && this.livePrice">{{ this.livePrice }} €</ng-container>
              <ng-container *ngIf="!component.content.livePrice || !this.livePrice">{{ component.content.price }}</ng-container>
            </span>
            <small class="c-card__pp" *ngIf="component.content.priceSuffix">
              <ng-container *ngIf="component.content.livePrice && this.livePrice">{{ component.content.priceSuffix }}</ng-container>
              <ng-container *ngIf="!component.content.livePrice || !this.livePrice">{{ component.content.priceSuffix }}</ng-container>
            </small>
          </ng-container>
          <div class="u-price-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </a>
</ng-template>

<ng-template #specialOffer let-component="component" let-link="link">
  <a class="c-card-home c-card-home--cards c-card-home--custom" target="{{component?.content?.ctaType?.id == 3  ? '_blank' : '_self'}}"
    [attr.href]="link?.length > 0 && !isLanding ? link : null"
    [ngClass]="{'is-disabled' : !link || link.length < 7 }">
    <div class="c-card-home__image c-card-home__image--overlay" style="background-image: url({{component.content.image}})">
      <span class="e-tag" *ngIf="component.content.badges.length > 0">
        <i class="icon-target"></i> //TODO
      </span>
    </div>
    <div class="c-card-home__content">
      <div class="c-card-home__text">
        <h4 [innerHTML]="component.content.title | trustHtml"></h4>
        <span [innerHTML]="component.content.subTitle | trustHtml"></span>
        <span [innerHTML]="component.content?.products[0]?.additionalInfo | trustHtml"></span>
      </div>
      <div class="c-card-home__footer">
        <div class="c-card-home__price" *ngIf="component?.content?.price && component?.content?.price?.length > 0">
          <span *ngIf="component.content.pricePrefix">{{component.content.pricePrefix}}</span>
          <span *ngIf="component.content.price" class="price">{{component.content.price}}</span>
          <span *ngIf="component.content.priceSuffix">{{component.content.priceSuffix}}</span>
        </div>
        <div class="c-card-home__cta" *ngIf="!component.content.price">
          <a class="cta btn btn--brand-color-03 btn--xs-large">
            {{component.content.ctaLabel}}
          </a>
        </div>
      </div>
    </div>
  </a>
</ng-template>

<ng-template #news let-component="component" let-link="link">
  <a class="c-home-news" [attr.href]="link?.length > 0 && !isLanding ? link : null"
    [ngClass]="{'is-disabled' : !link || link.length < 7 }">
    <div class="c-home-news__image" style="background-image: url({{component?.content?.image}})">
      <div class="c-home-news__text">
        <h3>{{component?.content?.title}}</h3>
        <p [innerHTML]=component?.content?.description></p>
      </div>
    </div>
  </a>
</ng-template>

<ng-template #banner let-component="component" let-link="link">
  <a class="c-home-banner" target="_blank" [attr.href]="link?.length > 0 && !isLanding ? link : null"
    [ngClass]="{'is-disabled' : !link || link.length < 5 }">
    <picture *ngIf="this.imageToUse">
      <img loading="lazy" src="{{this.imageToUse}}" alt="banner network" class="img-fluid"/>
    </picture>
  </a>
</ng-template>

<ng-template #destination let-component="component" let-link="link">
  <a class="c-home-destination" target="{{component?.content?.ctaType?.id == 3  ? '_blank' : '_self'}}"
    [attr.href]="link?.length > 0 && !isLanding ? link : null"
    [ngClass]="{'is-disabled' : !link || link.length < 7 }">
    <div class="c-home-destination__title">
      <h3>{{component?.content?.title}}</h3>
      <h5 [innerHtml]="component?.content?.subTitle"></h5>
    </div>
    <div class="c-home-destination__image c-home-destination__image--overlay" style="background-image: url({{component?.content?.image}})">

      <div class="c-card-home__footer">
        <div class="c-card-home__cta" *ngIf="!component?.content.price && component?.content.ctaLabel">
          <a class="cta btn btn--brand-color-03 btn--xs-large">
            {{component.content.ctaLabel}}
          </a>
        </div>
      </div>

    </div>
  </a>
</ng-template>

<ng-template #landing let-component="component" let-link="link" let-parent="parent">
  <div class="c-landing" style="background-image: url({{component?.content?.image}})"></div>
  <div class="c-landing__title" *ngIf="parent.hierarchyLevel">
    <h1 *ngIf="parent.type.basePath !== 'conad'">{{parent?.title}}</h1>
    <h1 *ngIf="parent.type.basePath === 'conad'">{{component?.content.title}}</h1>
    <h2 [innerHtml]="component?.content.subTitle"></h2>
  </div>
</ng-template>

<ng-template #static let-component="component" let-link="link" let-parent="parent">
  <section class="static-section" [ngClass]="{'is-even' : component.position % 2 === 0}">
    <div class="static-section__image" style="background-image: url({{component?.content?.image}})"></div>
    <div class="static-section__text">
      <h3>{{component?.content?.title}}</h3>
      <p [innerHtml]="component?.content?.description"></p>
      <a *ngIf="isCndAttributeVisible" class="cta btn btn--brand-color-03 btn--xs-large static-section__cta" [attr.href]="component.content.ctaTarget">
        {{component.content.ctaLabel}}
      </a>
    </div>
  </section>
</ng-template>

<ng-template #custom let-component="component" let-link="link">
  <a class="custom-card" [attr.href]="link?.length > 0 && !isLanding ? link : null" [ngClass]="{'is-disabled' : !link || link.length < 7 }">
    <div class="custom-card__image" style="background-image: url({{component?.content?.image}})"></div>
    <div class="custom-card__content">
      <div class="titles">
        <h3 [innerHtml]="component?.content?.title"></h3>
        <h5 [innerHtml]="component?.content?.subTitle"></h5>
      </div>
      <span *ngIf="component?.content?.ctaLabel" class="cta" [innerHtml]=component?.content?.ctaLabel></span>
    </div>
  </a>
</ng-template>